import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Client } from '../client/_types';

const readOnlyFields = [
  'nutrition_calories',
  'nutrition_carbs',
  'nutrition_fat',
  'nutrition_fiber',
  'nutrition_protein',
  'swipe_card',
  'secret',
  'sub_trainer_archived',
];

export function normalizeClient(client): Client {
  const camelized = camelcaseKeys(client, { deep: true });
  return camelized;
}

export function denormalizeClient(client: Partial<Client>) {
  const decamelized = decamelizeKeys(client, {
    deep: true,
  }) as Partial<Client> & { tag_list?: string[] };

  removeReadOnlyFields(decamelized, readOnlyFields);

  if (decamelized.tags) {
    (decamelized.tag_list as unknown as string) = decamelized.tags.join(',');
    delete decamelized.tags;
  }

  return decamelized;
}
